<template lang="pug">
f7-page#sign-up
  navbar-bridge-swift(title="新規登録" back @click="onClickBack")
  background-image
    sign-up-form(
      ref="form"
      v-model="isValid"
      :coachId="coachId"
      @click="onClickLink"
    )
    .footer-box
      .agree-message
        f7-link(@click="onClickLink('privacyPolicy')") プライバシーポリシー
        | 、
        f7-link(@click="onClickLink('termsOfUse')") 利用規約
        | に同意の上
      large-button(
        title="登録する"
        class="sign-up-button"
        :disabled="!isValid"
        @click="onClickSignUp"
      )
      f7-link(class="flow-link" @click="didTapShowLessonFlow")
        svg-icon(icon="question")
        | 詳しいレッスン内容を見てみる
      .separator
      .login-button-box
        p アカウントお持ちの方
          f7-link(class="login-link" @click="didTapLogin") ログイン
</template>

<style lang="scss" scoped>
.footer-box {
  position: absolute;
  bottom: 0px;
  min-height: 210px !important;
  @media (max-height: 630px) {
    min-height: 140px !important;
  }
  width: 100%;
  background: none;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  .agree-message {
    text-align: center;
    @extend %description;

    a {
      color: #fff;
      text-decoration: underline;
    }
  }
  .flow-link {
    @extend %narrow-button-text;
    margin: 8px 0;
    @media (max-height: 630px) {
      margin: 0;
    }

    .svg-icon {
      display: inline-flex;
      margin-right: 8px;
      width: 12px;
      height: 12px;
    }
  }
  .separator {
    height: 1px;
    margin: 0 24px;
    background: rgba(255, 255, 255, 0.4);
  }
  .login-button-box {
    text-align: center;
    margin: 8px 0;
    @media (max-height: 630px) {
      margin: 0;
    }

    p {
      @extend %body-text;
      margin: 0;

      a {
        @extend %login-link-text;
        margin-left: 32px;
      }
    }
  }
}
</style>

<script>
import { mapActions } from 'vuex'
import BridgeSwift from '@/components/mixins/BridgeSwift'
import Navbar from '@/components/organisms/Navbar'
import SignUpForm from '@/components/organisms/SignUpForm'
import LargeButton from '@/components/atoms/LargeButton'
import NavbarBridgeSwift from '@/components/organisms/NavbarBridgeSwift'

export default {
  components: {
    Navbar,
    SignUpForm,
    LargeButton,
    NavbarBridgeSwift,
  },
  data() {
    return {
      isValid: false,
      isSubmitted: false,
    }
  },
  computed: {
    coachId() {
      return this.$f7route.params.coachId
    },
  },
  mixins: [BridgeSwift],
  methods: {
    ...mapActions('signUp', ['signUp', 'initialize']),
    async onClickSignUp() {
      if (!this.isSubmitted) {
        this.isSubmitted = true

        try {
          await this.$refs['form'].submit()
        } finally {
          this.isSubmitted = false
        }

        if (this.coachId) {
          this.postMessageToSwift('didSignUpSuccessWithCoachId', this.coachId)
        } else {
          this.postMessageToSwift('didSignUpSuccess')
        }

        this.signUp(this.$refs['form']._data.email)

        this.$f7router.navigate({
          name: 'PublicSignUpDone',
          params: { coachId: this.coachId ? this.coachId : 'unselected_coach' },
        })
      }
    },
    onClickLink(link) {
      if (link == 'privacyPolicy') {
        this.postMessageToSwift('didTapPrivacyPolicy')
      } else if (link == 'termsOfUse') {
        this.postMessageToSwift('didTapTermsOfUse')
      }
    },
    didTapShowLessonFlow() {
      this.postMessageToSwift('didTapShowLessonFlow')
    },
    didTapLogin() {
      this.postMessageToSwift('didTapLogin')
    },
    onClickBack() {
      if (this.$f7router.history.length === 1) {
        this.postMessageToSwift('didTapBack')
      } else {
        this.$f7router.back()
      }
    },
  },
  mounted() {
    this.initialize()
    this.postMessageToSwift('didShowSignUp')
  },
}
</script>
